import { render, staticRenderFns } from "./DeptCourse.vue?vue&type=template&id=01fdb632&scoped=true"
import script from "./DeptCourse.vue?vue&type=script&lang=js"
export * from "./DeptCourse.vue?vue&type=script&lang=js"
import style0 from "./DeptCourse.vue?vue&type=style&index=0&id=01fdb632&prod&scoped=true&lang=css"
import style1 from "./DeptCourse.vue?vue&type=style&index=1&id=01fdb632&prod&lang=css"
import style2 from "./DeptCourse.vue?vue&type=style&index=2&id=01fdb632&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fdb632",
  null
  
)

export default component.exports